export default __webpack_public_path__ + "static/media/icon-close.2611e14d.svg";